/// <reference types="office-js" />
/* eslint-disable @typescript-eslint/no-unused-vars */

export interface Outlook {
  token: string;
  api: string;
  web: string;
  data?: object;
  emails?: {
    emailAddress: string;
    displayName: string;
    recipientType?: string;
  }[];
  createdId?: string;
  hideLoading?: () => void;
}
export interface OutlookResultMethods extends Outlook {
  goToPreviousPage: (initPage: boolean) => void;
  notify: (title: string, content?: string, isWarning?: boolean) => void;
  adjustIframe?: () => void;
  logout: () => void;
  saveEmails(entries: object[], isOtherEntries: boolean): boolean;
}

export type OfficeItem =
  | (Office.ItemCompose &
      Office.ItemRead &
      Office.Message &
      Office.MessageCompose &
      Office.MessageRead &
      Office.Appointment &
      Office.AppointmentCompose &
      Office.AppointmentRead)
  | undefined;

export type ClientTimeConverter = Pick<
  Office.Mailbox,
  'convertToLocalClientTime' | 'convertToUtcClientTime'
>;

export type WallTimeFields = Omit<Office.LocalClientTime, 'timezoneOffset'>;
